export const calculateBenchmarks = (providerRates?: number[]) => {
  const sortedProviderRates = providerRates?.sort((a, b) => a - b);

  const lowerBenchmark =
    sortedProviderRates?.[Math.floor(sortedProviderRates?.length / 3)];
  const upperBenchmark =
    sortedProviderRates?.[Math.floor((sortedProviderRates?.length * 2) / 3)];

  return { lowerBenchmark, upperBenchmark };
};

export const calculateDistribution = (
  providerRates?: number[],
  buckets: number = 10,
  clippedPercentage: number = 1,
) => {
  const initProviderRatesDistribution = Object.fromEntries(
    Array.from({ length: buckets }, (_, i) => [i, 0]),
  );

  const providerRatesDistribution = providerRates?.reduce((acc, curr) => {
    const index =
      curr < clippedPercentage
        ? Math.floor((curr * 100) / ((clippedPercentage * 100) / buckets))
        : buckets - 1;
    acc[index]++;
    return acc;
  }, initProviderRatesDistribution);

  return providerRatesDistribution;
};
